<template>
  <v-form @submit.prevent="validate()" ref="form">
    <v-snackbar v-model="snackbar.visibility" :timeout="snackbar.timeout" :color="snackbar.color">
      {{ snackbar.text }}
      <v-btn text @click="remove()" v-show="snackbar.confirm">Confirm</v-btn>
      <v-btn text @click="setSnackbar({ ...snackbar, visibility: false })">{{ snackbar.cancelText }}</v-btn>
    </v-snackbar>
    <v-container grid-list-md>
      <v-row dense>
        <v-col cols="12">
          <v-text-field v-model="campus.name" label="Name" :rules="[rules.required]" />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field v-model="campus.code" label="Code" :rules="[rules.required]" />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field v-model="campus.way" label="Way" :rules="[rules.required]" append-outer-icon="fa-question" @click:append-outer="openWayDocs()" />
        </v-col>
        <v-col cols="12">
          <color-picker v-model="campus.color" />
        </v-col>
        <v-col cols="12">
          <v-btn type="submit" block color="primary">Submit</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import rules from '@/mixins/rules'
import CampusesService from '@/services/CampusesService'

export default {
  name: 'CampusForm',
  mixins: [rules],
  computed: {
    ...mapGetters([
      'campuses',
      'snackbar'
    ]),
    campus () {
      const campus = this.campuses.filter((campus) => campus._id === this.$route.params.id)

      return (campus.length) ? campus[0] : {}
    }
  },
  methods: {
    ...mapMutations([
      'setSnackbar'
    ]),
    async validate () {
      if (this.$refs.form.validate()) {
        try {
          let response
          if (this.$route.params.id) {
            response = await CampusesService.updateCampus(this.campus)
          } else {
            response = await CampusesService.addCampus(this.campus)
          }

          this.setSnackbar({
            ...this.snackbar,
            text: response.data.message,
            color: 'success',
            cancelText: 'Close',
            confirm: false,
            visibility: true
          })

          this.$router.push('/admin/campuses')
        } catch (e) {
          if (e.response.status === 403) {
            this.$router.push('/login')
          }

          this.setSnackbar({
            ...this.snackbar,
            text: 'Unable to modify campus',
            color: 'error',
            cancelText: 'Close',
            confirm: false,
            visibility: true
          })

          console.error(e)
        }
      }
    },
    openWayDocs () {
      window.open('https://help.openstreetmap.org/questions/46469/finding-a-node-or-a-way-on-openstreetmap', '_blank')
    }
  }
}
</script>
